'use client'
import { GameTopToolbar } from 'src/components/GameTopToolbar/GameTopToolbar'
import { useSoundEffect } from 'src/hooks/useSoundEffect'
import { useGetIsSidebarOpen, useUIActions } from 'src/store/ui'

type Props = Readonly<{
  showLogo?: boolean
}>

export function GameTopToolbarContainer({ showLogo = true }: Props) {
  const { sidebarOpenToggled } = useUIActions()
  const isSidebarOpen = useGetIsSidebarOpen()
  const { playEffect } = useSoundEffect()
  const handleToggleSidebar = () => {
    sidebarOpenToggled()
    playEffect('click')
  }

  return (
    <GameTopToolbar
      isSidebarOpen={isSidebarOpen}
      onToggleSidebar={handleToggleSidebar}
      showLogo={showLogo}
    />
  )
}
